var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_vm._v(" " + _vm._s(_vm.location.location_type.display_name) + " "), !_vm.hideArrow ? _c('span', [_vm._v("→")]) : _vm._e(), _vm.hasLocationPermission(_vm.location.location_type.identifier, _vm.location.identifier, 'locations.contactinfo.edit') ? _c('router-link', {
    attrs: {
      "to": _vm.getRoute
    },
    domProps: {
      "textContent": _vm._s(_vm.location.display_name)
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.location.display_name))])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }